import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ExchangeTransactionAgreement } from 'src/app/models/exchange-transaction';
import { ExchangeTransactionService } from 'src/app/api/exchange-transaction.service';

@Component({
  selector: 'crypto-transaction-agreements',
  templateUrl: './crypto-transaction-agreements.component.html',
  styleUrls: ['./crypto-transaction-agreements.component.scss']
})
export class CryptoTransactionAgreementsComponent implements OnInit {
  @Output() submit = new EventEmitter<void>();

  loading = false;
  error: string = null;
  agreements: ExchangeTransactionAgreement[];

  constructor(private exchangeTransactionService: ExchangeTransactionService) { }

  ngOnInit() {
    this.getAgreements();
  }

  getAgreements() {
    this.loading = true;
    this.exchangeTransactionService.getPendingAgreements().subscribe(response => {
      this.loading = false;
      this.agreements = response;

      if (!this.agreements) {
        this.submit.emit();
      }
    });
  }

  onSubmit() {
    this.loading = null;

    this.exchangeTransactionService.agreeOnDepositAgreements(this.agreements.map(item => item.type)).subscribe(response => {
      this.loading = false;

      if (response) {
        this.agreements = null;
        this.submit.emit();
      } else {
        this.error = 'Something went wrong, please try again later';
      }
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }
}
